/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AmountDecimalValidationError,
  AmountDecimalValidationError$inboundSchema,
  AmountDecimalValidationError$Outbound,
  AmountDecimalValidationError$outboundSchema,
} from "./amountdecimalvalidationerror.js";

export type CreatePaymentLinkLineItemOptionValidationError = {
  name?: string | undefined;
  group?: string | undefined;
  priceModifier?: AmountDecimalValidationError | undefined;
  quantity?: string | undefined;
};

/** @internal */
export const CreatePaymentLinkLineItemOptionValidationError$inboundSchema:
  z.ZodType<
    CreatePaymentLinkLineItemOptionValidationError,
    z.ZodTypeDef,
    unknown
  > = z.object({
    name: z.string().optional(),
    group: z.string().optional(),
    priceModifier: AmountDecimalValidationError$inboundSchema.optional(),
    quantity: z.string().optional(),
  });
/** @internal */
export type CreatePaymentLinkLineItemOptionValidationError$Outbound = {
  name?: string | undefined;
  group?: string | undefined;
  priceModifier?: AmountDecimalValidationError$Outbound | undefined;
  quantity?: string | undefined;
};

/** @internal */
export const CreatePaymentLinkLineItemOptionValidationError$outboundSchema:
  z.ZodType<
    CreatePaymentLinkLineItemOptionValidationError$Outbound,
    z.ZodTypeDef,
    CreatePaymentLinkLineItemOptionValidationError
  > = z.object({
    name: z.string().optional(),
    group: z.string().optional(),
    priceModifier: AmountDecimalValidationError$outboundSchema.optional(),
    quantity: z.string().optional(),
  });

export function createPaymentLinkLineItemOptionValidationErrorToJSON(
  createPaymentLinkLineItemOptionValidationError:
    CreatePaymentLinkLineItemOptionValidationError,
): string {
  return JSON.stringify(
    CreatePaymentLinkLineItemOptionValidationError$outboundSchema.parse(
      createPaymentLinkLineItemOptionValidationError,
    ),
  );
}
export function createPaymentLinkLineItemOptionValidationErrorFromJSON(
  jsonString: string,
): SafeParseResult<
  CreatePaymentLinkLineItemOptionValidationError,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      CreatePaymentLinkLineItemOptionValidationError$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'CreatePaymentLinkLineItemOptionValidationError' from JSON`,
  );
}
